const uuidv4 = require("uuid/v4");

import { HeaderElement } from "@/modules/header/viewmodels/HeaderElement";

export default class Header {
  constructor(Settings) {
    /**
     * * Settings
     * id: String
     * backbutton: Boolean
     * css: String
     * elements: Array
     * clear: Boolean
     * tabs: Array
     * bg: String|css class
     * help: Function
     */

    let settings;

    // Fallback to default values if no settings object is given
    if (!Settings || typeof Settings !== "object") {
      settings = {};
    } else {
      settings = Settings;
    }

    this.Id = settings.id && settings.id !== undefined ? settings.id : uuidv4();

    this.Bg = settings.bg || "bg-gray-700";

    this.BackButton =
      settings.backbutton === undefined || settings.backbutton === null
        ? false
        : settings.backbutton;

    this.Classes =
      typeof settings.css === "string"
        ? settings.css + " " + this.Bg
        : "text-white " + this.Bg;

    this.Clear = settings.clear;

    this.Elements = [];

    this.Help = settings.help || false;

    this.Tabs = settings.tabs || false;

    if (
      settings.elements &&
      Array.isArray(settings.elements) &&
      settings.elements.length > 0
    ) {
      settings.elements.forEach((e) =>
        this.Elements.push(new HeaderElement(e))
      );
    }
  }

  getElements(location) {
    if (
      ["left", "center", "right"].includes(location) &&
      this.Elements.length > 0
    ) {
      return this.Elements.filter((e) => e.location === location);
    }
    return false;
  }
}
